import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ShipperResponse } from 'tms-lib';
import { ShipperInterfaceHeader } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceHeaderService extends TmsWebBaseEditCreateService<
  ShipperInterfaceHeader,
  ShipperInterfaceHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShipperInterfaceHeader', $localize`Shipper Interface Header`);
  }

  bookShipping(id: string, shippingNotes: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/BookShipping`, { id, shippingNotes });
  }

  reprintLabel(id: string, shipperInterfaceHeaderId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ReprintLabel`, {
      id,
      shipperInterfaceHeaderId,
    });
  }

  changeShipper(shipperId: string, documentId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ChangeShipper`, { shipperId, documentId });
  }
}
